<template>
  <common-dialog
    @opened="onOpened"
    ref="dialog"
    :title="title"
    width="1300px"
    :in-dialog="inDialog"
  >
    <list ref="list" :isDialog="false"> </list>

    <template slot="footer">
      <el-button type="primary" size="small" @click="submitmul">提交</el-button>
    </template>
  </common-dialog>
</template>
  <script>
import commonDialog from "@/components/common/dialog";
import list from "./list";
import listDialogMixins from "@/mixins/listDialog";
export default {
  components: { commonDialog, list },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "用户列表",
    },
    showstatus: {
      type: Boolean,
      default: true,
    },
    sameBusiness: {
      type: Boolean,
      default: false,
    },
    pickChild: {
      type: Boolean,
      default: false,
    },
    isMallGoods: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      params: {
        GoodsName: "", //名称
        BrandId: null, //品牌

        State: null, //状态 - 0：停用，1：正常
        SaleState: 1, //上下架状态 - 0：下架，1：上架
        TradeMode: null,
        FilingsOrderids: "", //对应的保税商品备案序号
        FilingsNames: "", //对应的保税商品备案名称
        IsMonth: null,
        IsNewStyle: null,
      },
      ChooseIds: [],
      ChooseData: [],
      checkRow: [],
      ChooseModelIds: [],
      ChooseModelData: [],
      Brands: [],
      api: require("@/api/goods/info").default,
      TypePlatforms: [],
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
      brand_api: require("@/api/goods/brand").default,
      typeplatform_api: require("@/api/goods/typeplatform").default,

      props: {
        value: "RecordId",
        label: "TypeName",
        children: "children",
      },
    };
  },
  mounted() {
    this.brand_api.list({ State: 1 }).then((res) => {
      if (res.Code == 0) {
        this.Brands = res.Data;
      }
    });
    this.typeplatform_api.list({ State: 1 }).then((res) => {
      if (res.Code == 0) {
        this.TypePlatforms = this.$commonJs.toTreeData(
          res.Data,
          "RecordId",
          "TypeIdParent",
          "children"
        );
      }
    });
  },
  methods: {
    onResetQuery() {
      console.log("onResetQuery", this.params);
      if (this.$refs.picker1) this.$refs.picker1.clear();
      if (this.$refs.picker2) this.$refs.picker2.clear();
    },
    onTbSelect(selection, row) {
      console.log("ontbselect");
      if (this.checkRow.length > 0) {
        this.checkRow.forEach((e, index) => {
          if (row.RecordId == e.RecordId) {
            this.checkRow.splice(index, 1);
            return;
          }
          if (index == this.checkRow.length - 1) {
            this.checkRow.push(row);
          }
        });
      } else {
        this.checkRow.push(row);
      }
    },
    selectAll(selection, recordId) {
      if (selection.length > 0) {
        selection.forEach((n) => {
          var has = false;
          this.checkRow.forEach((e) => {
            if (n.RecordId == e.RecordId) {
              has = true;
            }
          });
          if (!has) {
            this.checkRow.push(n);
          }
        });
      } else {
        for (let i = 0; i < this.checkRow.length; i++) {
          var e = this.checkRow[i];
          if (e.RecordId == orderId) {
            this.checkRow.splice(i, 1);
            i--;
          }
        }
      }
    },
    expandChange(row, t) {
      var has = false;
      t.forEach((e) => {
        if (e.RecordId == row.RecordId) {
          has = true;
          return;
        }
      });
      if (!has) {
        return;
      }
      this.checkRow.forEach((e) => {
        if (e.RecordId == row.RecordId) {
          this.$nextTick(() => {
            this.$refs["prod" + row.RecordId].toggleRowSelection(e, true);
          });
        }
      });
    },
    onOpened(data) {
      this.ChooseIds = [];
      this.ChooseData = [];
      this.checkRow = [];
      this.ChooseModelData = [];
      this.ChooseModelIds = [];
      // this.$refs.list.params.OrderStatus = this.custype
      // this.query();
    },
    selectItem(row) {
      this.ChooseIds.push(row.RecordId);
      this.ChooseData.push(row);
      console.log("this.ChooseData", this.ChooseData);

      this.ChooseData.map((item) => {
        if (row.RecordId == item.RecordId) {
          row.OrderGoods.forEach((item) => {
            item.Quantity = item.MainunitCount - (item.SendCount || 0);
          });
        }
      });
    },
    chanelItem(row, index) {
      this.ChooseData.splice(index, 1);
      this.ChooseIds.splice(index, 1);
      this.ChooseModelData.forEach((e, index) => {
        if (e.OrdermainId == row.RecordId) {
          this.ChooseModelData.splice(index, 1);
        }
      });
      this.ChooseModelIds = this.ChooseModelData.map((item) => item.RecordId);
    },
    selectItem2(row) {
      this.ChooseModelIds.push(row.RecordId);
      this.ChooseModelData.push(row);
      console.log("this.ChooseModelData", this.ChooseModelData);
    },
    chanelItem2(row, index) {
      console.log("chanelItem2", row);
      this.ChooseModelIds.forEach((e, index) => {
        if (e == row.RecordId) {
          this.ChooseModelIds.splice(index, 1);
        }
      });
      this.ChooseModelData.forEach((e, index) => {
        if (e.RecordId == row.RecordId) {
          this.ChooseModelData.splice(index, 1);
        }
      });
      if (this.ChooseData.length > 0) {
        this.ChooseData.forEach((e, index) => {
          if (e.RecordId == row.OrdermainId) {
            var length = this.ChooseModelData.filter(
              (x) => x.OrdermainId == e.RecordId
            ).length;

            if (length < 1) {
              this.ChooseData.splice(index, 1);
            }
          }
        });
        this.ChooseIds = this.ChooseData.map((item) => item.RecordId);
      }
    },
    submitmul() {
      var issumit = true;
      let rows = this.$refs.list.getCheckedRows();
      console.log(rows, "row");
      if (rows.length == 0) {
        this.$message.warning("请选择用户");
        return;
      }
      var arr2 = { tableData: [] };
      rows.forEach((item) => {
       arr2.tableData.push({
        RecordId:item.RecordId,
        AdTitle:item.PersonName
       });
      });
      this.onSelect(arr2);
   
    },
    summaryCount(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.label == "总长度") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return Number(((prev * 1000 + curr * 1000) / 1000).toFixed(4));
            } else {
              return Number(prev - 0).toFixed(4);
            }
          }, 0);
        } else if (column.label == "主单位数量") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return (prev * 1000 + curr * 1000) / 1000;
            } else {
              return prev;
            }
          }, 0);
        } else if (column.label == "辅助单位数量") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return (prev * 1000 + curr * 1000) / 1000;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "-";
        }
      });
      return sums;
    },
  },
};
</script>
  <style lang="scss" scoped>
.choosetable {
  margin: 10px;
  /deep/ .el-table__expanded-cell {
    padding: 0;
  }
  /deep/ .el-card__header {
    padding: 10px 20px;
  }
}
</style>
  